/**
 * @generated SignedSource<<7197a20285baad36806af69218333283>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "BasketCollectDate",
    "kind": "LinkedField",
    "name": "basketAvailableCollectDates",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "date",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "price",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SelectCollectDateModalQuery",
    "selections": (v0/*: any*/),
    "type": "ClientAppQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SelectCollectDateModalQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "22da6d92ac152a9995ca14856f454987",
    "id": null,
    "metadata": {},
    "name": "SelectCollectDateModalQuery",
    "operationKind": "query",
    "text": "query SelectCollectDateModalQuery {\n  basketAvailableCollectDates {\n    date\n    price\n  }\n}\n"
  }
};
})();

node.hash = "65fd9eee7397b3132143a37cb0b1d3aa";

module.exports = node;
